module.exports = __webpack_public_path__ + "static/jon-fbf587a31a3f0dae0a3d16834faf346b.jpeg";